export default __webpack_public_path__ + "static/consulting-727490556adcc6b13ab079e8c239fdd3.png";